import { handleServerErrors, PrintError } from 'core/infrastructure';
import { SessionProvider } from 'core/infrastructure';
import { OrderingFacade } from 'pos/facades';
import { TicketDTO } from 'core/api';
import { Message } from 'core/ui-next/modal';

export default async function autoPreparePreviousIfNeeded(previousTicket: Nullable<TicketDTO>) {

	const session = SessionProvider.getCurrent();
	if (!session.UseAutomaticPreparation)
		return;

	try {

		const ticket = previousTicket;
		if (ticket === null)
			return;

		if (ticket.IsEmpty)
			return;

		await handleServerErrors(async () => await OrderingFacade.prepareTickets([ticket.Id], true), {
			onPrintError: async (error: PrintError) => { await Message.show(error.message); }
		});
	}
	catch {
		// Como es una autpreparación automática ignoramos el error
	}
}
